function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#2684FF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M2360.6,1166l-1063-1063l-103-103L394.4,800.2L28.5,1166c-38,38.2-38,100,0,138.3l731,731l435.1,434.9 l800.1-800.2l12.5-12.4l353.4-352.9c38.3-38.1,38.6-100,0.5-138.3C2361,1166.3,2360.8,1166.2,2360.6,1166L2360.6,1166z  M1194.6,1600.4l-365.2-365.2l365.2-365.2l365.1,365.2L1194.6,1600.4z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M1199.6,874.9C960.5,635.8,959.3,248.5,1197,8L397.8,806.8l434.9,434.9L1199.6,874.9z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "st2",
  d: "M1565.8,1239.1l-366.1,366.2c240.1,240.2,240.1,629.5,0,869.7l801.4-801L1565.8,1239.1z"
});

const SvgJira = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2389.5 2470.3",
    style: {
      enableBackground: "new 0 0 2389.5 2470.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 588.5495,
    y1: 1326.9861,
    x2: 542.2995,
    y2: 1373.2261,
    gradientTransform: "matrix(11.028 0 0 11.028 -5356.2363 -14128.6328)"
  }, React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#0052CC"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2684FF"
    }
  })), _ref4, React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 600.7969,
    y1: 1459.8435,
    x2: 646.9569,
    y2: 1413.6935,
    gradientTransform: "matrix(11.028 0 0 11.028 -5356.2363 -14128.6328)"
  }, React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#0052CC"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2684FF"
    }
  })), _ref5);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgJira, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Jira.c9648ec6.svg";
export { ForwardRef as ReactComponent };